<template>
    <div class="main-wrap">
        <div
            class="sidebar-menu-con"
            :style="{ width: shrink ? '60px': '200px', overflow: shrink ? 'visible' : 'auto' }">
            <shrinkable-menu
                :shrink="shrink"
                :menuLists="menuLists"
                :openNames="openNames"
                @changeSQ="changeSQ"
                @changeZK="changeZK"
            >
                <div slot="logo" :class="['sidebar-menu-logo', shrink ? '' : 'sidebar-menu-logo-max-wrap']">
                    <img v-if="!shrink" class="sidebar-menu-logo-max" src="@/resources/images/common/logo-max.png" />
                    <img v-if="shrink" class="sidebar-menu-logo-min" src="@/resources/images/common/logo-min.png" />
                </div>
            </shrinkable-menu>
        </div>
        
        <div :class="['main-header-con', shrink ? 'main-header-con-shrink' : '']">
            <div :class="['main-header-nav-icon', shrink ? 'main-header-nav-icon-rotate' : '']" @click="toggleMenu">
                <Button type="text">
                    <Icon type="navicon-round" size="26"></Icon>
                </Button>
            </div>
            <breadcrumb-path
                :breadcrumb-path="breadcrumbPath"
                v-if="breadcrumbPath.length > 1"
            ></breadcrumb-path>
            <div class="main-header-user">
                <Dropdown class="main-header-user-operate" placement="bottom-end" @on-click="operateUserInfo">
                    <a href="javascript:void(0)">
                        <span>{{modifyUserInfo.name}}</span>
                        <Icon type="arrow-down-b"></Icon>
                        <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg"></Avatar>
                    </a>
                    <DropdownMenu slot="list">
                        <DropdownItem name="modifyPassword">修改密码</DropdownItem>
                        <DropdownItem name="logoff">退出</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </div>
        <div :class="['single-page-con', shrink ? 'single-page-con-shrink' : '']" :style="{left: shrink ? '60px' : '200px'}">
            <div class="single-page">
                <transition name="slide" mode="out-in">
                    <router-view></router-view>
                </transition>
            </div>
        </div>
        <Modal v-model="modifyPasswordModal" width="380">
            <p slot="header" style="color: #ff994f;">
                <Icon type="information-circled"></Icon>
                <span>修改密码</span>
            </p>
            <div>
                <Form ref="modifyPasswordForm" :rules="modifyPasswordFormValid" :model="modifyUserInfo" :label-width="90" label-position="right">
                    <FormItem label="用户名">
                        <Input v-model="modifyUserInfo.name" disabled />
                    </FormItem>
                    <FormItem label="原密码" prop="old_password">
                        <Input type="password" v-model="modifyUserInfo.old_password" />
                    </FormItem>
                    <FormItem label="密码" prop="new_password">
                        <Input type="password" v-model="modifyUserInfo.new_password" placeholder="6位以上" />
                    </FormItem>
                    <FormItem label="请重复密码" prop="new_password_confirmation">
                        <Input type="password" v-model="modifyUserInfo.new_password_confirmation" placeholder="6位以上" />
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type="primary" size="large" long @click="modifyPassword">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import shrinkableMenu from '@/components/sidebar-menu/shrinkable-menu';
    import breadcrumbPath from '@/components/breadcrumb-path/breadcrumb';
    import CommonUtils from '@/resources/utils/common-utils';
    import { validEqualPassword } from '@/resources/utils/validate-utils';

    export default {
        data() {
            return {
                shrink: false,
                modifyPasswordModal: false,
                modifyPasswordFormValid: {
                    old_password: [
                        { required: true, message: '请输入原密码', trigger: 'blur' }
                    ],
                    new_password: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '请输入至少6位密码', trigger: 'blur' },
                        { validator: this.checkPwdEqual, trigger: 'blur' }
                    ],
                    new_password_confirmation: [
                        { required: true, message: '请输入重复的新密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '请输入至少6位密码', trigger: 'blur' },
                        { validator: this.checkPwdEqual, trigger: 'blur' }
                    ]
                },
                modifyUserInfo: {
                    userName: '',
                    old_password: '',
                    new_password: '',
                    new_password_confirmation: ''
                }
            }
        },

        computed: {
            menuLists() {
                return this.$store.state.app.menuLists;
            },

            openNames() {
                return this.$store.state.app.openedSubmenuArr;
            },

            breadcrumbPath() {
                return this.$store.state.app.currentPath;
            }
        },

        methods: {
            changeSQ () {
                this.shrink = true;
            },
            changeZK () {
                this.shrink = false;
            },
            toggleMenu() {
                this.shrink = !this.shrink;
            },

            checkShrinkMenu() {
                let winWidth = document.body.clientWidth;
                winWidth <= 1200 ? this.shrink = true : this.shrink = false;
            },

            operateUserInfo(name) {
                if (name === 'logoff') {
                    CommonUtils.logoff(this);
                } else {
                    this.modifyPasswordModal              = true;
                    this.modifyUserInfo.pastPassword      =   '';
                    this.modifyUserInfo.newPassword       =   '';
                    this.modifyUserInfo.newRepeatPassword =   '';
                }
            },

            modifyPassword() {
                const _self = this;

                this.$refs.modifyPasswordForm.validate(valid => {
                    if(valid) {
                        this.$store.commit('modifyPassword', {
                            data: _self.modifyUserInfo,
                            successFunc(res) {
                                _self.$Notice.success({
                                    title: res.message,
                                    duration: 1.5,
                                    onClose() {
                                        localStorage.removeItem('userInfo');
                                        _self.$router.push('/login');
                                    }
                                });
                            }
                        });
                    }
                });
            },

            checkPwdEqual(rule, value, callback) {
                return validEqualPassword(this.modifyUserInfo.new_password, this.modifyUserInfo.new_password_confirmation, callback);
            }
        },

        mounted() {
            const _self = this;

            this.modifyUserInfo = JSON.parse(localStorage.getItem('userInfo'));

            // this.checkShrinkMenu();

            // window.onresize = function() {_self.checkShrinkMenu();};
        },

        components: {
            shrinkableMenu,
            breadcrumbPath
        }
    }
</script>

<style lang="scss">
    @import '../../resources/scss/main/main';
</style>



// WEBPACK FOOTER //
// src/views/main/main.vue